module.exports = function getResource(label, vars = []) {
    let resources = {
        selectUpToSamples: `Sélectionnez jusqu’à ${vars[0]} échantillon(s)`,
        done: 'Terminé'
    };

    return resources[label];
};
